import {Component, Input, OnInit} from '@angular/core';
import {ViewCell} from 'ng2-smart-table';
import {ApiService} from '../../../../@core/service/api.service';

@Component({
  selector: 'ngx-form-list-business-renderer',
  template: '{{renderValue}}',
})
export class FormListBusinessRendererComponent implements ViewCell, OnInit {
  renderValue: string;

  @Input() value: any;
  @Input() rowData: any;

  constructor(private api: ApiService) {
    this.api.reloadRegions();
  }

  ngOnInit() {
    const b = this.api.getRegion(this.value);
    if (b != null)
      this.renderValue = b.name;
    else
      this.renderValue = 'error';
  }

}
